export default __webpack_public_path__ + "static/media/dized-logo-background.c1e543bb.svg";